import React from 'react';
import BlogPost from "../BlogPost";

const AlcernsLighthouse = () => {
    return (
        <BlogPost
            id="AlcernsLighthouse"
            title="The Mists of Alcern's Lighthouse"
            content={
                < >
                    &quot;I don't know what to tell you&quot; the gruff voice moans with
                    annoyance &quot;the
                    mist comes in and I stay inside doing my job.&quot; Elroy lifts his forehead from an
                    open palm hand shaking it softly and looks at his guest quizzically pondering
                    aloud &quot;why would you want to know about the mist anyways? It's just mist.&quot;
                    <br/><br/>
                    &quot;Oh come now Honey, they are only being inquisitive&quot; a voice calls out
                    with a
                    touch of sweet mockery only to be followed by the man's wife entering with a pot of
                    tea
                    and two cups. “Elroy can be a bit grumpy when he knows a storm is coming in. Don’t
                    mind
                    it, he's sweet in the center.&quot; She winks at the guest and gives Elroy a little
                    peck
                    before whispering &quot;already put the honey in your cup&quot; and exiting with a
                    coy
                    giggle. Elroy looks back only catching a glimpse of Janet before she vanishes around
                    the
                    corner. He sighs heavily before pouring himself and his guest the tea. Taking a long
                    sip
                    he looks across the table &quot;tell me again Croemartee what's your interest in the
                    mists.&quot;
                    <br/><br/>
                    The gentleman reaches down and with a long pale fingers delicately lifts the tea cup
                    to
                    take a sip. He smiles and with a voice that carries an air of scholarly training
                    answers &quot;I've been studying historical records and believe these mists to be”
                    he
                    lapses for a moment looking for the right word before finishing with “too
                    consistent.&quot;
                    <br/><br/>
                    &quot;Alright, but what does that mean?&quot;
                    <br/><br/>
                    &quot;I do not know but I'd like to. It's why I'm here after all&quot; Croemartee
                    says
                    raising and spreading his hands in front of him like a blooming flower hiding a
                    secret
                    within. His fine robe's sleeves brush the table as he moves almost knocking over the
                    tea
                    cup. Elroy finds it odd that a robe of such fine material, with decorative
                    embroidery
                    along the seams too, would be so oversized but his guests frame is so slight that
                    the
                    robe still looks as it it will swallow him whole like a dragon turtle to a sailor
                    caught
                    in its maw.
                    <br/><br/>
                    &quot;Well lad here's what I can say. I'd never come or go during the fog. Too
                    dangerous
                    first off. Can't see if and where the waters come in. Go for a walk and might end up
                    swept away. After all, the land between here and the mainland isn't big, you know it
                    yourself having walked here, but give it some hours and parts of it will start to
                    vanish
                    as the tides change. For that matter I wouldn't leave even if it was safe
                    because&quot; he puffs up his chest as if preparing to below a grand exultation only
                    to
                    be cut off by Janet, again from the kitchen &quot;because you’re the fourth
                    generation
                    lighthouse keeper, right Honey?&quot; She peeks around the corner flashing a smile
                    and
                    finishing &quot;It's your duty after all to make sure that all ships make it safely
                    into
                    the harbor of Alcern! If it wasn't for this lighthouse how could the great merchants
                    of
                    this fair city ever hope to do business.&quot;
                    <br/><br/>
                    &quot;Yes, Sweetheart, that is, indeed, what I was going to say&quot; he lets out
                    with a
                    bit of exasperation again watching Janet disappear back to her sizzling pans just
                    barely
                    audible from the table. &quot;With that all said, I've had folks leave here, only
                    two
                    mind you, one when I was a mere child and once when I when I was a young man.
                    Neither
                    made it back to the mainland. My father said that they both must have been hit by a
                    wave
                    and swept away. Beyond that I've heard that a half dozen or so have tried to reach
                    the
                    lighthouse when the mists are out and also gone missing but that's more a story to
                    scare
                    children than fact by any account I've been able to find.&quot;
                    Croemartee drums his fingers softness as he watches the smile change to that
                    pondering
                    smile creeping across his face as Elroy goes on with his account. He waits a moment,
                    letting Elroy shift uncomfortably in the near silence, broken by the sound of a
                    boiling
                    pot of water that has just joined the orchestra of kitchen work in the
                    background. &quot;So things go missing in the mist. Seems normal by all accounts and
                    rather logical given the tidal patterns that have been recorded to accompany them.”
                    Croemartee’s fingers stop and, lifting his hands tighter, leans forward a bit. “So
                    things go missing, but you haven't mentioned if anything ever comes
                    out.&quot; Elroy's
                    complexion shifts from its usual politely red tone to something more in line with
                    the
                    pale complexion Croemartee wears. Elroy watches his guest’s smile twists up at the
                    corners and wonders if their eyes, like those of the orange cat that wanders the
                    island,
                    will narrow, as the feline’s do in the moment when prey comes into sight. &quot;Come
                    now, Elroy” Croemartee continues making the implied question a reality. “What has
                    the
                    mist given us?&quot;
                    <br/><br/>
                    Elroy lifts himself warily and steps around his guest to a large trunk in the
                    corner.
                    Well cared for, the old studded leather appears finely crafted. “It was clearly well
                    loved and taken care of over what must have been at least a few generations. Oh and
                    well
                    oiled too” Croemartee thinks to himself as Elroy lifts the lid begins to rummage
                    before
                    removing a wooden box about the size of a small knapsack. Elroy apologizes and moves
                    towards the kitchen. Even with him trying to hide the box Croemartee noticing signs
                    of
                    hidden compartments, and the mechanisms for unlocking them, on the box as it passes.
                    Alone, for the moment, he dips his pen and sketches the trunk and box before taking
                    a
                    few quick notes: about dozen missing; at least 40 years; mist tied to special
                    inconsistent patterns; local lore ingrained; no returnees, but something has.
                    Croemartee
                    lifts the nib and considered for a moment before Elroy reenters holding a small bag,
                    just a bit larger than a potion of healing, by a drawstring.
                    <br/><br/>
                    Elroy gently lowers the bag onto the table before sitting and eyeing Croemartee
                    again.
                    This guest was an odd one for sure. His gaunt face, with cheek bones almost
                    protruding,
                    and eyes, giving the impression that they were sunken to the point where one might
                    assume he was dead. For that matter it almost made Elroy feel that he was sitting
                    with a
                    corpse. Still, there was something about the strangeness that made sharing the
                    object
                    feel good, no, Elroy correct to himself, alright. Only alright.
                    <br/><br/>
                    &quot;This was found by my grandfather&quot; Elroy expresses in a loud whisper as if
                    he's both trying to let Croemartee hear him but also make sure no one can. With a
                    slight
                    tremor in his hands Elroy begins to undo the drawstring &quot;I was told he found it
                    just sitting on the ground in the middle of the land after the mists came in. He
                    assumed
                    it must have just washed up there. He never liked talking about it but&quot; he
                    pulls
                    back the bag &quot;I was told it moved a bit&quot; a hollow thunk as a dried human
                    hand
                    severed just above the wrist hits the table. It's skin a deep grey color, the life
                    long
                    drained from it, except for a spiraling design painted or maybe tattooed on it in
                    the
                    center. Three strands wrapping out from a central point with a circular motion. Each
                    strand, equidistant from one another, curving slightly forward before swinging the
                    other
                    one way and finishing with the tips curving completely over, in the original
                    direction,
                    and in on itself.
                    <br/><br/>
                    Elroy averts his eyes but Croemartee leans in mouthing &quot;fascinating&quot; to
                    himself. He feels the power behind the yellow pattern reach into his mind as if the
                    tendrils were rising off the flesh and extending themselves in an attempt to wriggle
                    behind his eyes and then deeper still. &quot;No no, I haven't given you any such
                    permission and I don't intend to. Now sit still while I do my analysis&quot; he
                    thinks
                    to himself as he reaches into his bag, lifts out a book, and flips it open. The tome
                    with it's soft worn black leather, an embossed pattern his friend Nero once made,
                    now
                    only barely visible, and it's pages and pages of hand written notes which he flips
                    through rapidly looking for the correct solution. Finding the specific page he
                    begins
                    mumbling to himself and gesturing with his free hand. His concentration unwavering
                    as
                    Janet enters to announce &quot;the food will be” before stopping herself mid
                    sentence to
                    watch. Finally he places the tome down and, with his newly freed hand, plucks a
                    white
                    feather and pearl from his bag continuing with his mumbling and gestures. Finishing
                    Croemartee lifts the pearl, in the open palm of his left hand, and lowers the
                    feather
                    with his right to touch the ocher symbol. The moment they make contact both the
                    pearl
                    and feather give out a hiss and disintegrating.
                    <br/><br/>
                    &quot;Very interesting&quot; Croemartee finally announces brushing the dust off his
                    hands. &quot;Thank you so much for the hospitality! I really wish I could stay for
                    the
                    meal but I must be on my way. Elroy, please put that away. It's a ghastly thing and
                    I
                    wouldn't recommend having it out when the mists come in.&quot; Elroy stares, wide
                    eyed,
                    for a moment, and, snapping back to awareness, begins to hastily place the hand back
                    in
                    it's bag and with Janet’s help returns it to it’s box and then the trunk.
                    <br/><br/>
                    &quot;You’re leaving, but the mist is coming in? You said it yourself&quot; Janet
                    questions as she turns back from the trunk and makes her way back to the cacophony
                    emanating from the kitchen &quot;and didn't Elroy just finish explaining how folks
                    don't
                    tend to fair so well out there with the mists and tides?&quot;
                    <br/><br/>
                    &quot;Correct you are Janet but my research simple demands it. I do hope you'll both
                    wish me the best of luck and not worry too much&quot; and without waiting for a
                    response
                    Croemartee stand, lifting his bag, turning in a single motion, and walks straight to
                    the
                    door. As he swings it open, his spare hand rises, lifted the hood of his robe and,
                    with
                    a smile and nod at the couple, he exits, closing the door politely behind him.
                    <br/><br/>
                    The wind begin to carry a frigid character, that very specific kind that one can
                    only
                    find at the precipice of the oceans. The mist was already rather thick and
                    Croemartee
                    had no time to spare. He quickly marched down the lighthouse path. The grassy hill
                    quickly turning to large rocks, smaller ones, pebbles, and finally just dirt and
                    bare
                    rock. He identified the easiest path and began walking as the mist thickened keeping
                    his
                    ears perked up for the sound of waves that might rush towards him. &quot;Probably
                    should
                    have send a note to Nero or Val'aran&quot; he thought aloud to the mist only a
                    moment
                    before he vanished from the stretch between the lighthouse and the beaches east of
                    Alcern.
                </>
            }
            photoSrc=""
            photoAlt=""
            noteText="It's been about three years since then. Haven't seen him myself but Nero told me it only took a year for him to pop back up. I'm hoping I find him soon, after all, these mists sounds very interesting. - Datrius Cerid"
        />
    );
};

export default AlcernsLighthouse;
